
import i18n from "../services/i18n"// Egasi №1/№4 (2026-08-31): menyu guruhlari — ADMIN STANDART varianti.
// Har foydalanuvchi buni O'ZIGA moslaydi (tartib, yashirish, guruhni
// o'zgartirish, hatto guruhlashni butunlay o'chirish) — MenuPrefs orqali.
export interface MenuGroupDef {
  key: string
  label: string
  /** i18n kaliti (msg 436: guruh nomlari ham 3 tilda) */
  labelKey?: string
  items: string[] // menuItems.title lar
}

export const MENU_GROUP_DEFS: MenuGroupDef[] = [
  // Egasi (2026-08-31): 2 ta panel ham standart guruhda tursin
  { key: "g-panel", label: i18n.t("gPanel"), labelKey: "gPanel", items: ["home", "globalPanel"] },
  { key: "g-sales", label: i18n.t("saleCount"), labelKey: "gSales", items: ["sale", "returnSale", "discounts", "orders", "moneyComments", "orderComments"] },
  { key: "g-purch", label: i18n.t("gPurch"), labelKey: "gPurch", items: ["purchase", "factoryPurchases", "returnPurchase", "expenses", "factories", "orderToMain"] },
  { key: "g-stock", label: i18n.t("warehouse"), labelKey: "gStock", items: ["warehouseDesk", "warehouseBoard", "goods", "residues", "inventoryCounts", "showcases", "transfers", "defects", "warehouses"] },   // tog'a #3141: Витрина «Склад» guruhida — «Продажи» nomli guruh sotuv berilgandek ko'rsatardi
  { key: "g-fin", label: i18n.t("gFin"), labelKey: "gFin", items: ["money", "reports"] },
  { key: "g-partner", label: i18n.t("gPartner"), labelKey: "gPartner", items: ["counterparties", "customers", "shops", "broadcasts", "tenantsPanel", "partnerApplications"] },   // tog'a #3563 2-qism: «Заявки партнёров»
  { key: "g-hr", label: i18n.t("gHr"), labelKey: "gHr", items: ["usersDirectory", "managers", "employees", "salaries", "kpi", "attendance"] },
  { key: "g-docs", label: i18n.t("gDocs"), labelKey: "gDocs", items: ["declarant", "declarations", "contracts"] },
  { key: "g-sys", label: i18n.t("gSys"), labelKey: "gSys", items: ["roles", "control", "auditLogs", "backups", "legalPages", "DataAdmin", "trash"] },
]

/** Element standart bo'yicha qaysi guruhga tegishli (topilmasa null = guruhsiz) */
export function defaultGroupOf(title: string): string | null {
  const g = MENU_GROUP_DEFS.find((x) => x.items.includes(title))
  return g ? g.key : null
}

// Foydalanuvchining shaxsiy menyu sozlamasi (serverda mainUsers.MenuPrefs JSON)
export interface MenuPrefs {
  /** true = guruhlash BUTUNLAY o'chirilgan (tekis ro'yxat) */
  flat?: boolean
  /** yashirilgan bo'limlar (link/route bo'yicha) */
  hidden?: string[]
  /** shaxsiy tartib (link/route ro'yxati) */
  order?: string[]
  /** element -> guruh kaliti; null = guruhsiz (yuqorida) */
  groups?: Record<string, string | null>
  /** Egasi №2 (2026-08-31): foydalanuvchi O'ZI yaratgan guruhlar (icon = emoji) */
  customGroups?: { key: string; label: string; icon?: string }[]
  /** Egasi (2026-08-31, 2-to'lqin): guruhlarning KO'RINISH TARTIBI (kalitlar ro'yxati) */
  groupOrder?: string[]
  /** Egasi (2026-08-31, 2-to'lqin): butunlay yashirilgan guruhlar (ichidagilar bilan; «Главная» himoyada) */
  hiddenGroups?: string[]
}

export const MENU_PREFS_CACHE_KEY = "menu_prefs_cache"

export function readCachedPrefs(): MenuPrefs | null {
  try {
    const s = localStorage.getItem(MENU_PREFS_CACHE_KEY)
    return s ? (JSON.parse(s) as MenuPrefs) : null
  } catch {
    return null
  }
}
